import { createAction, props } from '@ngrx/store';

export enum SessionAuthActions {
  AutoLogin = '[Session/Auth] Auto Login',
  Authenticated = '[Session/Auth] Authenticated',
  RestoreSession = '[Session/Auth] Restore Session',
  FullAuthenticated = '[Session/Auth] Full Authenticated',
  SetToken = '[Session/Auth] Set Token',
  ClearToken = '[Session/Auth] Clear Token',
  LogoutOAuth = '[Session/Auth] Logout OAuth',
  SecondFactorEnforced = '[Session/Auth] Second Factor Enforced',
  SecondFactorFailed = '[Session/Auth] Second Factor Failed',
}

export const setToken = createAction(
  SessionAuthActions.SetToken,
  props<{
    token: string;
  }>(),
);

export const clearToken = createAction(SessionAuthActions.ClearToken);

export const autoLogin = createAction(SessionAuthActions.AutoLogin);

export const authenticated = createAction(
  SessionAuthActions.Authenticated,
  props<{ token: string }>(),
);

export const restoreSession = createAction(
  SessionAuthActions.RestoreSession,
  props<{ token: string }>(),
);


export const fullAuthenticated = createAction(
  SessionAuthActions.FullAuthenticated,
);

export const logoutOAuth = createAction(SessionAuthActions.LogoutOAuth);

export const secondFactorEnforced = createAction(
  SessionAuthActions.SecondFactorEnforced,
);

export const secondFactorFailed = createAction(
  SessionAuthActions.SecondFactorFailed,
);
